'use strict';

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var DEFAULT_DURATION = 0.3;
var DEFAULT_EASE_TYPE = 'linear';
var DEFAULT_DIRECTION = 'normal';
var DEFAULT_FILLMODE = 'none';
var RUNNING = 'running';
var PAUSED = 'paused';
var ALL = 'all';

var calculateTotalDuration = function calculateTotalDuration(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? DEFAULT_DURATION : _ref$duration,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$overlay = _ref.overlay,
      overlay = _ref$overlay === void 0 ? 0 : _ref$overlay;
  return duration + delay - overlay || 0;
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

function getSequenceId(sequenceIndex, sequenceId, defaultValue) {
  if (isUndefined(sequenceId) && isUndefined(sequenceIndex)) {
    return defaultValue || 0;
  }

  if (sequenceIndex && sequenceIndex >= 0) {
    return sequenceIndex;
  }

  if (sequenceId) {
    return sequenceId;
  }

  return 0;
}

var AnimateContext = React__namespace.createContext({
  animationStates: {},
  register: function register() {}
});

function AnimateGroup(_ref2) {
  var play = _ref2.play,
      _ref2$sequences = _ref2.sequences,
      sequences = _ref2$sequences === void 0 ? [] : _ref2$sequences,
      children = _ref2.children;

  var _React__namespace$use = React__namespace.useState({}),
      _React__namespace$use2 = _slicedToArray(_React__namespace$use, 2),
      animationStates = _React__namespace$use2[0],
      setAnimationStates = _React__namespace$use2[1];

  var animationsRef = React__namespace.useRef({});
  var register = React__namespace.useCallback(function (data) {
    var sequenceIndex = data.sequenceIndex,
        sequenceId = data.sequenceId;

    if (!isUndefined(sequenceId) || !isUndefined(sequenceIndex)) {
      animationsRef.current[getSequenceId(sequenceIndex, sequenceId)] = data;
    }
  }, []);
  React__namespace.useEffect(function () {
    var sequencesToAnimate = Array.isArray(sequences) && sequences.length ? sequences : Object.values(animationsRef.current);
    var localAnimationState = {};
    (play ? sequencesToAnimate : _toConsumableArray(sequencesToAnimate).reverse()).reduce(function (previous, _ref3, currentIndex) {
      var sequenceId = _ref3.sequenceId,
          sequenceIndex = _ref3.sequenceIndex,
          _ref3$duration = _ref3.duration,
          duration = _ref3$duration === void 0 ? DEFAULT_DURATION : _ref3$duration,
          delay = _ref3.delay,
          overlay = _ref3.overlay;
      var id = getSequenceId(sequenceIndex, sequenceId, currentIndex);
      var currentTotalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      });
      var totalDuration = currentTotalDuration + previous;
      localAnimationState[id] = {
        play: play,
        pause: !play,
        delay: (delay || 0) + previous,
        controlled: true
      };
      return totalDuration;
    }, 0);
    setAnimationStates(localAnimationState); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play]);
  return React__namespace.createElement(AnimateContext.Provider, {
    value: {
      animationStates: animationStates,
      register: register
    }
  }, children);
}

var secToMs = function secToMs(ms) {
  return (ms || 0) * 1000;
};

function Animate(props) {
  var play = props.play,
      children = props.children,
      render = props.render,
      start = props.start,
      end = props.end,
      _props$complete = props.complete,
      complete = _props$complete === void 0 ? '' : _props$complete,
      onComplete = props.onComplete,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? DEFAULT_DURATION : _props$duration,
      _props$easeType = props.easeType,
      easeType = _props$easeType === void 0 ? DEFAULT_EASE_TYPE : _props$easeType,
      sequenceId = props.sequenceId,
      sequenceIndex = props.sequenceIndex;
  var onCompleteTimeRef = React__namespace.useRef();

  var _React__namespace$use3 = React__namespace.useState(start || {}),
      _React__namespace$use4 = _slicedToArray(_React__namespace$use3, 2),
      style = _React__namespace$use4[0],
      setStyle = _React__namespace$use4[1];

  var _React__namespace$use5 = React__namespace.useContext(AnimateContext),
      register = _React__namespace$use5.register,
      _React__namespace$use6 = _React__namespace$use5.animationStates,
      animationStates = _React__namespace$use6 === void 0 ? {} : _React__namespace$use6;

  var id = getSequenceId(sequenceIndex, sequenceId);
  React__namespace.useEffect(function () {
    if (!isUndefined(sequenceIndex) && sequenceIndex >= 0 || sequenceId) {
      register(props);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  React__namespace.useEffect(function () {
    var animationState = animationStates[id] || {};
    setStyle(_objectSpread(_objectSpread({}, play || animationState.play ? end : start), {}, {
      transition: "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(animationState.delay || delay, "s")
    }));

    if (play && (complete || onComplete)) {
      onCompleteTimeRef.current = setTimeout(function () {
        complete && setStyle(complete);
        onComplete && onComplete();
      }, secToMs((animationState.delay || delay) + duration));
    }

    return function () {
      return onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, [id, animationStates, play, duration, easeType, delay, onComplete, start, end, complete]);
  return render ? render({
    style: style
  }) : React__namespace.createElement("div", {
    style: style
  }, children);
}

var camelCaseToDash = function camelCaseToDash(camelCase) {
  return camelCase ? camelCase.replace(/[A-Z]/g, function (c) {
    return "-".concat(c.toLowerCase());
  }) : '';
};

var generateKeyframes = function generateKeyframes(keyframes) {
  var animationLength = keyframes.length;
  return keyframes.reduce(function (previous, keyframe, currentIndex) {
    var keyframePercentage = parseFloat((100 / (animationLength - 1)).toFixed(2)) * currentIndex;

    if (typeof keyframe === 'string') {
      return "".concat(previous, " ").concat(keyframePercentage, "% {").concat(keyframe, "}");
    }

    var keys = Object.keys(keyframe);

    if (keys.length && isNaN(+keys[0])) {
      var keyframeContent = keys.reduce(function (acc, key) {
        return "".concat(acc, " ").concat(camelCaseToDash(key), ": ").concat(keyframe[key], ";");
      }, '');
      return "".concat(previous, " ").concat(keyframePercentage, "% {").concat(keyframeContent, "}");
    }

    return "".concat(previous, " ").concat(keys[0], "% {").concat(keyframe[keys[0]], "}");
  }, '');
};

function createStyle(_ref4) {
  var keyframes = _ref4.keyframes,
      animationName = _ref4.animationName;
  return "@keyframes ".concat(animationName, " {").concat(generateKeyframes(keyframes), "}");
}

function createTag(_ref5) {
  var keyframes = _ref5.keyframes,
      animationName = _ref5.animationName;

  var _a, _b, _c, _d;

  var styleTag = document.querySelector('style[data-id=rsi]');

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.setAttribute('data-id', 'rsi');
    document.head.appendChild(styleTag);
  }

  var index = (_c = (_b = (_a = styleTag.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;

  try {
    (_d = styleTag.sheet) === null || _d === void 0 ? void 0 : _d.insertRule(createStyle({
      keyframes: keyframes,
      animationName: animationName
    }), index);
  } catch (e) {
    console.error('react simple animate, error found during insert style ', e); // eslint-disable-line no-console
  }

  return {
    styleTag: styleTag,
    index: index
  };
}

var deleteRules = function deleteRules(sheet, deleteName) {
  if (!sheet) {
    return;
  }

  var index = Object.values(sheet.cssRules).findIndex(function (_ref6) {
    var name = _ref6.name;
    return name === deleteName;
  });

  if (index >= 0) {
    sheet.deleteRule(index);
  }
};

var createRandomName = function createRandomName() {
  return "RSI-".concat(Math.random().toString(36).substr(2, 9));
};

var getPlayState = function getPlayState(pause) {
  return pause ? PAUSED : RUNNING;
};

function AnimateKeyframes(props) {
  var children = props.children,
      _props$play = props.play,
      play = _props$play === void 0 ? false : _props$play,
      _props$pause = props.pause,
      pause = _props$pause === void 0 ? false : _props$pause,
      render = props.render,
      _props$duration2 = props.duration,
      duration = _props$duration2 === void 0 ? DEFAULT_DURATION : _props$duration2,
      _props$delay2 = props.delay,
      delay = _props$delay2 === void 0 ? 0 : _props$delay2,
      _props$easeType2 = props.easeType,
      easeType = _props$easeType2 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType2,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? DEFAULT_DIRECTION : _props$direction,
      _props$fillMode = props.fillMode,
      fillMode = _props$fillMode === void 0 ? DEFAULT_FILLMODE : _props$fillMode,
      _props$iterationCount = props.iterationCount,
      iterationCount = _props$iterationCount === void 0 ? 1 : _props$iterationCount,
      sequenceIndex = props.sequenceIndex,
      keyframes = props.keyframes,
      sequenceId = props.sequenceId;
  var pauseValue;
  var animationNameRef = React__namespace.useRef({
    forward: '',
    reverse: ''
  });
  var controlled = React__namespace.useRef(false);
  var styleTagRef = React__namespace.useRef({
    forward: null,
    reverse: null
  });
  var id = getSequenceId(sequenceIndex, sequenceId);

  var _React__namespace$use7 = React__namespace.useContext(AnimateContext),
      register = _React__namespace$use7.register,
      _React__namespace$use8 = _React__namespace$use7.animationStates,
      animationStates = _React__namespace$use8 === void 0 ? {} : _React__namespace$use8;

  var animateState = animationStates[id] || {};

  var _React__namespace$use9 = React__namespace.useState(false),
      _React__namespace$use10 = _slicedToArray(_React__namespace$use9, 2),
      forceUpdate = _React__namespace$use10[1];

  React__namespace.useEffect(function () {
    var styleTag = styleTagRef.current;
    var animationName = animationNameRef.current;
    animationNameRef.current.forward = createRandomName();
    var result = createTag({
      animationName: animationNameRef.current.forward,
      keyframes: keyframes
    });
    styleTagRef.current.forward = result.styleTag;
    animationNameRef.current.reverse = createRandomName();
    result = createTag({
      animationName: animationNameRef.current.reverse,
      keyframes: keyframes.reverse()
    });
    styleTagRef.current.reverse = result.styleTag;
    register(props);

    if (play) {
      forceUpdate(true);
    }

    return function () {
      var _a, _b;

      deleteRules((_a = styleTag.forward) === null || _a === void 0 ? void 0 : _a.sheet, animationName.forward);
      deleteRules((_b = styleTag.reverse) === null || _b === void 0 ? void 0 : _b.sheet, animationName.reverse);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (animateState.controlled && !controlled.current) {
    pauseValue = animateState.pause;

    if (!animateState.pause) {
      controlled.current = true;
    }
  } else {
    pauseValue = pause;
  }

  var style = {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(animateState.delay || delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(getPlayState(pauseValue), " ").concat(((animateState.controlled ? animateState.play : play) ? animationNameRef.current.forward : animationNameRef.current.reverse) || '')
  };
  return render ? render({
    style: style
  }) : React__namespace.createElement("div", {
    style: style || {}
  }, children);
}

function useAnimate(props) {
  var start = props.start,
      end = props.end,
      complete = props.complete,
      onComplete = props.onComplete,
      _props$delay3 = props.delay,
      delay = _props$delay3 === void 0 ? 0 : _props$delay3,
      _props$duration3 = props.duration,
      duration = _props$duration3 === void 0 ? DEFAULT_DURATION : _props$duration3,
      _props$easeType3 = props.easeType,
      easeType = _props$easeType3 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType3;
  var transition = React__namespace.useMemo(function () {
    return "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(delay, "s");
  }, [duration, easeType, delay]);

  var _React__namespace$use11 = React__namespace.useState({
    isPlaying: false,
    style: _objectSpread(_objectSpread({}, start), {}, {
      transition: transition
    })
  }),
      _React__namespace$use12 = _slicedToArray(_React__namespace$use11, 2),
      animate = _React__namespace$use12[0],
      setAnimate = _React__namespace$use12[1];

  var isPlaying = animate.isPlaying,
      style = animate.style;
  var onCompleteTimeRef = React__namespace.useRef();
  React__namespace.useEffect(function () {
    if ((onCompleteTimeRef.current || complete) && isPlaying) {
      onCompleteTimeRef.current = setTimeout(function () {
        if (onComplete) {
          onComplete();
        }

        if (complete) {
          setAnimate(_objectSpread(_objectSpread({}, animate), {}, {
            style: complete
          }));
        }
      }, secToMs(delay + duration));
    }

    return function () {
      return onCompleteTimeRef.current && clearTimeout(onCompleteTimeRef.current);
    };
  }, [isPlaying]);
  return {
    isPlaying: isPlaying,
    style: style,
    play: React__namespace.useCallback(function (isPlaying) {
      setAnimate(_objectSpread(_objectSpread({}, animate), {}, {
        style: _objectSpread(_objectSpread({}, isPlaying ? end : start), {}, {
          transition: transition
        }),
        isPlaying: isPlaying
      }));
    }, [])
  };
}

function useAnimateKeyframes(props) {
  var _props$duration4 = props.duration,
      duration = _props$duration4 === void 0 ? DEFAULT_DURATION : _props$duration4,
      _props$delay4 = props.delay,
      delay = _props$delay4 === void 0 ? 0 : _props$delay4,
      _props$easeType4 = props.easeType,
      easeType = _props$easeType4 === void 0 ? DEFAULT_EASE_TYPE : _props$easeType4,
      _props$direction2 = props.direction,
      direction = _props$direction2 === void 0 ? DEFAULT_DIRECTION : _props$direction2,
      _props$fillMode2 = props.fillMode,
      fillMode = _props$fillMode2 === void 0 ? DEFAULT_FILLMODE : _props$fillMode2,
      _props$iterationCount2 = props.iterationCount,
      iterationCount = _props$iterationCount2 === void 0 ? 1 : _props$iterationCount2,
      keyframes = props.keyframes;
  var animationNameRef = React__namespace.useRef({
    forward: '',
    reverse: ''
  });
  var styleTagRef = React__namespace.useRef({
    forward: null,
    reverse: null
  });

  var _React__namespace$use13 = React__namespace.useContext(AnimateContext),
      register = _React__namespace$use13.register;

  var _React__namespace$use14 = React__namespace.useState(null),
      _React__namespace$use15 = _slicedToArray(_React__namespace$use14, 2),
      isPlaying = _React__namespace$use15[0],
      setIsPlaying = _React__namespace$use15[1];

  var _React__namespace$use16 = React__namespace.useState(false),
      _React__namespace$use17 = _slicedToArray(_React__namespace$use16, 2),
      isPaused = _React__namespace$use17[0],
      setIsPaused = _React__namespace$use17[1];

  React__namespace.useEffect(function () {
    var styleTag = styleTagRef.current;
    var animationName = animationNameRef.current;
    animationNameRef.current.forward = createRandomName();
    var result = createTag({
      animationName: animationNameRef.current.forward,
      keyframes: keyframes
    });
    styleTagRef.current.forward = result.styleTag;
    animationNameRef.current.reverse = createRandomName();
    result = createTag({
      animationName: animationNameRef.current.reverse,
      keyframes: keyframes.reverse()
    });
    styleTagRef.current.reverse = result.styleTag;
    register(props);
    return function () {
      var _a, _b;

      deleteRules((_a = styleTag.forward) === null || _a === void 0 ? void 0 : _a.sheet, animationName.forward);
      deleteRules((_b = styleTag.reverse) === null || _b === void 0 ? void 0 : _b.sheet, animationName.reverse);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var style = {
    animation: "".concat(duration, "s ").concat(easeType, " ").concat(delay, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(getPlayState(isPaused), " ").concat(isPlaying === null ? '' : isPlaying ? animationNameRef.current.forward : animationNameRef.current.reverse)
  };
  return {
    style: style,
    play: setIsPlaying,
    pause: setIsPaused,
    isPlaying: !!isPlaying
  };
}

function createArrayWithNumbers(length) {
  return Array.from({
    length: length
  }, function () {
    return null;
  });
}

function useAnimateGroup(props) {
  var _props$sequences = props.sequences,
      sequences = _props$sequences === void 0 ? [] : _props$sequences;
  var defaultArray = createArrayWithNumbers(sequences.length).map(function (_, index) {
    return props.sequences[index].start;
  });

  var _React__namespace$use18 = React__namespace.useState(defaultArray),
      _React__namespace$use19 = _slicedToArray(_React__namespace$use18, 2),
      styles = _React__namespace$use19[0],
      setStyles = _React__namespace$use19[1];

  var _React__namespace$use20 = React__namespace.useState(false),
      _React__namespace$use21 = _slicedToArray(_React__namespace$use20, 2),
      isPlaying = _React__namespace$use21[0],
      setPlaying = _React__namespace$use21[1];

  var animationNamesRef = React__namespace.useRef([]);
  var styleTagRef = React__namespace.useRef([]);
  React__namespace.useEffect(function () {
    sequences.forEach(function (_ref7, i) {
      var keyframes = _ref7.keyframes;

      if (!Array.isArray(keyframes)) {
        return;
      }

      if (!animationNamesRef.current[i]) {
        animationNamesRef.current[i] = {};
        styleTagRef.current[i] = {};
      }

      animationNamesRef.current[i].forward = createRandomName();
      var result = createTag({
        animationName: animationNamesRef.current[i].forward,
        keyframes: keyframes
      });
      styleTagRef.current[i].forward = result.styleTag;
      animationNamesRef.current[i].reverse = createRandomName();
      result = createTag({
        animationName: animationNamesRef.current[i].reverse,
        keyframes: keyframes.reverse()
      });
      styleTagRef.current[i].reverse = result.styleTag;
    });
    var styleTags = styleTagRef.current;
    var animationNames = animationNamesRef.current;
    return function () {
      return Object.values(animationNames).forEach(function (_ref8, i) {
        var forward = _ref8.forward,
            reverse = _ref8.reverse;

        var _a, _b;

        deleteRules((_a = styleTags[i].forward) === null || _a === void 0 ? void 0 : _a.sheet, forward);
        deleteRules((_b = styleTags[i].reverse) === null || _b === void 0 ? void 0 : _b.sheet, reverse);
      });
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var play = React__namespace.useCallback(function (isPlay) {
    var totalDuration = 0;
    var animationRefWithOrder = isPlay ? animationNamesRef.current : _toConsumableArray(animationNamesRef.current).reverse();
    var styles = (isPlay ? sequences : _toConsumableArray(sequences).reverse()).map(function (current, currentIndex) {
      var _current$duration = current.duration,
          duration = _current$duration === void 0 ? DEFAULT_DURATION : _current$duration,
          _current$delay = current.delay,
          delay = _current$delay === void 0 ? 0 : _current$delay,
          overlay = current.overlay,
          keyframes = current.keyframes,
          _current$iterationCou = current.iterationCount,
          iterationCount = _current$iterationCou === void 0 ? 1 : _current$iterationCou,
          _current$easeType = current.easeType,
          easeType = _current$easeType === void 0 ? DEFAULT_EASE_TYPE : _current$easeType,
          _current$direction = current.direction,
          direction = _current$direction === void 0 ? DEFAULT_DIRECTION : _current$direction,
          _current$fillMode = current.fillMode,
          fillMode = _current$fillMode === void 0 ? DEFAULT_FILLMODE : _current$fillMode,
          _current$end = current.end,
          end = _current$end === void 0 ? {} : _current$end,
          _current$start = current.start,
          start = _current$start === void 0 ? {} : _current$start;
      var delayDuration = currentIndex === 0 ? delay : totalDuration;
      var transition = "".concat(ALL, " ").concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s");
      totalDuration = calculateTotalDuration({
        duration: duration,
        delay: delay,
        overlay: overlay
      }) + totalDuration;
      return keyframes ? {
        animation: "".concat(duration, "s ").concat(easeType, " ").concat(delayDuration, "s ").concat(iterationCount, " ").concat(direction, " ").concat(fillMode, " ").concat(RUNNING, " ").concat(isPlay ? animationRefWithOrder[currentIndex].forward : animationRefWithOrder[currentIndex].reverse)
      } : _objectSpread(_objectSpread({}, isPlay ? end : start), {}, {
        transition: transition
      });
    });
    setStyles(isPlay ? styles : _toConsumableArray(styles).reverse());
    setPlaying(isPlay);
  }, []);
  return {
    styles: styles,
    play: play,
    isPlaying: isPlaying
  };
}

exports.Animate = Animate;
exports.AnimateGroup = AnimateGroup;
exports.AnimateKeyframes = AnimateKeyframes;
exports.useAnimate = useAnimate;
exports.useAnimateGroup = useAnimateGroup;
exports.useAnimateKeyframes = useAnimateKeyframes;